import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getActiveAnnouncement } from '../../announcements/_redux/actions';

const AnnouncementBanner = ({ announcement, getActiveAnnouncement, location }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // 在客户端路由下显示公告
    const isClientRoute = !location.pathname.startsWith('/admin') && !location.pathname.startsWith('/backoffice');
    if (isClientRoute) {
      getActiveAnnouncement();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (announcement && announcement.state === 1 && announcement.content) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [announcement]);

  // 在客户端路由下渲染
  const isClientRoute = !location.pathname.startsWith('/admin') && !location.pathname.startsWith('/backoffice');
  if (!isClientRoute || !isVisible || !announcement?.content) {
    return null;
  }

  return (
    <div className="AnnouncementBanner">
      <div className="AnnouncementBanner__content">
        <div dangerouslySetInnerHTML={{ __html: announcement.content.replace(/\n/g, '<br/>') }} />
      </div>
      <style jsx>{`
        .AnnouncementBanner {
          background-color: #fff3cd;
          border: 1px solid #ffeaa7;
          border-radius: 4px;
          padding: 10px 15px;
          margin-bottom: 15px;
          text-align: center;
          color: #856404;
          font-size: 14px;
        }
        .AnnouncementBanner__content {
          word-break: break-word;
          text-align: left;
          display: inline-block;
          max-width: 100%;
        }
      `}</style>
    </div>
  );
};

const mapStateToProps = state => ({
  announcement: state.client.announcements?.activeAnnouncement,
});

const mapDispatchToProps = {
  getActiveAnnouncement: () => getActiveAnnouncement.request(),
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AnnouncementBanner));
